module.exports = __webpack_public_path__ + "img/clock-nine-thirty.d51fc03b.svg";